import { toast } from 'react-toastify';

export const toastrMsg = (toastrText, toastrType) => {
    toast(toastrText, {
        type: toastrType
    })
};